import React from "react";
import styles from "./CreateOrderChip.module.scss";

// ITAM-2583: the docked "create order" affordance shown while a consult prefill
// is available (phase CHIP). It never opens the form directly — clicking it just
// re-opens the confirmation prompt (the lifecycle owns that transition). It sits
// fixed bottom-right, below the modal layer and clear of the top VideoConsultAlert.

export interface CreateOrderChipProps {
  callerName: string;
  onOpen: () => void;
}

const CreateOrderChip: React.FC<CreateOrderChipProps> = ({
  callerName,
  onOpen,
}) => (
  <button
    type="button"
    className={styles.chip}
    onClick={onOpen}
    aria-label={`Kreiraj porudžbinu za ${callerName}`}
  >
    <span className={styles.label}>Poruči za: {callerName}</span>
  </button>
);

export default CreateOrderChip;
